// Horizon's slideshow-slide toggles aria-hidden on inactive slides but leaves their interactive descendants focusable — mirror aria-hidden onto `inert` to close that gap.
function syncSlideInert(slide) {
  slide.inert = slide.getAttribute('aria-hidden') === 'true';
}

document.querySelectorAll('slideshow-slide[aria-hidden]:not([data-mc-inert-bound])').forEach((slide) => {
  slide.dataset.mcInertBound = '';
  syncSlideInert(slide);

  new MutationObserver(() => syncSlideInert(slide)).observe(slide, {
    attributes: true,
    attributeFilter: ['aria-hidden'],
  });
});
